import Vue from "vue"
// import axios from "axios" // <-- WIRD NICHT MEHR GEBRAUCHT
import socketService from "@/socketService"
import api from "@/api" // <-- DAS IST JETZT UNSERE QUELLE

const state = {
  // (State bleibt 1:1 gleich)
  chatGroups: [],
  chatMessages: {},
  activeGroupId: null,
  isLoadingGroups: false,
  isLoadingMessages: false,
  isLoadingMoreMessages: false,
  chatPageInfo: {},
  userPresence: {},
  replyingToMessage: null,
  editingMessage: null,
  viewedUserProfile: null, // Hält das User-Objekt für das Popup
  commonGroups: [], // Hält die gemeinsamen Gruppen
  isLoadingProfile: false, // Lade-Spinner für das Popup
  typingUsers: {},
  globalToastMessage: null,
  loadedGroupHistories: [],
  pinboardPersonal: [], // Hält die ChatMessage-Objekte
  pinboardGlobal: [], // Hält die GlobalPin-Objekte
  isPinboardLoading: false,
  activeView: "chat", // 'chat' oder 'pinboard'
  searchResults: [], // Liste der Treffer
  isSearching: false, // Lade-Indikator für Suche
  isJumping: false, // Indikator, wenn wir gerade zu einer Nachricht springen
  searchQuery: "", // Aktueller Suchbegriff (um UI Status zu halten)
  isHistoryMode: false,
  messageDrafts: {}, // Map von groupId -> string (Draft Nachrichtentext)
}

const mutations = {
  SET_HISTORY_MODE(state, status) {
    state.isHistoryMode = status
  },
  SET_SEARCH_RESULTS(state, results) {
    state.searchResults = results
  },
  SET_IS_SEARCHING(state, status) {
    state.isSearching = status
  },
  SET_SEARCH_QUERY(state, query) {
    state.searchQuery = query
  },
  SET_IS_JUMPING(state, status) {
    state.isJumping = status
  },
  CLEAR_SEARCH(state) {
    state.searchResults = []
    state.searchQuery = ""
  },
  SET_ACTIVE_VIEW(state, viewName) {
    state.activeView = viewName
    if (viewName === "pinboard") {
      state.activeGroupId = null // Pinboard schließt den Chat
    }
  },
  SAVE_MESSAGE_DRAFT(state, { groupId, draftText }) {
    if (!draftText) {
      Vue.delete(state.messageDrafts, groupId)
    } else {
      Vue.set(state.messageDrafts, groupId, draftText)
    }
  },
  CLEAR_MESSAGE_DRAFT(state, groupId) {
    Vue.delete(state.messageDrafts, groupId)
  },
  SET_PINBOARD_LOADING(state, isLoading) {
    state.isPinboardLoading = isLoading
  },
  SET_PINBOARD_PINS(state, { globalPins, personalPins }) {
    state.pinboardGlobal = globalPins
    state.pinboardPersonal = personalPins
  },
  // Für optimistische Updates (sofortige UI-Änderung)
  ADD_PERSONAL_PIN(state, message) {
    // Finde die volle Nachricht im Cache, falls nur ID übergeben
    const fullMessage = state.chatMessages[message.groupId]?.find((m) => m._id === message._id) || message
    state.pinboardPersonal.unshift(fullMessage)
  },
  REMOVE_PERSONAL_PIN(state, messageId) {
    state.pinboardPersonal = state.pinboardPersonal.filter((m) => m._id !== messageId)
  },
  UPDATE_GROUP_ON_NEW_MESSAGE(state, { message, myUserId }) {
    const groupId = message.groupId.toString()
    const group = state.chatGroups.find((g) => g._id === groupId)
    if (group) {
      // 1. Aktualisiere die 'letzte Nachricht' (DAS IST DER FIX FÜR DICH)
      Vue.set(group, "lastMessage", message) // 2. Prüfe auf Badges (nur wenn es nicht meine eigene Nachricht ist)

      if (message.senderId._id !== myUserId) {
        Vue.set(group, "hasUnread", true) // 3. Prüfe auf @Mentions
        const isMentioned = (message.mentions || []).some((mentionId) => (mentionId._id || mentionId) === myUserId)
        if (isMentioned) {
          Vue.set(group, "isMentioned", true)
        }
      }

      // 4. "Richtig Geil"-Bonus: Sortiere die Liste neu
      const sorted = [...state.chatGroups].sort((a, b) => {
        if (!a.lastMessage) return 1
        if (!b.lastMessage) return -1
        return new Date(b.lastMessage.createdAt) - new Date(a.lastMessage.createdAt)
      })

      state.chatGroups = sorted
    }
  }, // NEU:
  MARK_GROUP_READ(state, { groupId }) {
    const group = state.chatGroups.find((g) => g._id === groupId)
    if (group) {
      Vue.set(group, "hasUnread", false)
      Vue.set(group, "isMentioned", false)
    }
  },
  MARK_HISTORY_LOADED(state, groupId) {
    if (!state.loadedGroupHistories.includes(groupId)) {
      state.loadedGroupHistories.push(groupId)
    }
  },
  REMOVE_GROUP_FROM_LIST(state, groupId) {
    state.chatGroups = state.chatGroups.filter((g) => g._id !== groupId)
    // Wenn es die aktive Gruppe war, schließe das Chat-Fenster
    if (state.activeGroupId === groupId) {
      state.activeGroupId = null
    }
  },
  SET_GLOBAL_TOAST(state, message) {
    // message kann 'null' oder ein Objekt sein
    state.globalToastMessage = message
  },
  ADD_TYPING_USER(state, { groupId, userId }) {
    if (!state.typingUsers[groupId]) {
      Vue.set(state.typingUsers, groupId, [])
    }
    const isAlreadyTyping = state.typingUsers[groupId].includes(userId)
    if (!isAlreadyTyping) {
      state.typingUsers[groupId].push(userId) // <-- Pushe nur die ID
    }
  },

  REMOVE_TYPING_USER(state, { groupId, userId }) {
    if (state.typingUsers[groupId]) {
      const newList = state.typingUsers[groupId].filter((id) => id !== userId) // <-- Filtere nach ID
      Vue.set(state.typingUsers, groupId, newList)
    }
  },
  SET_VIEWED_PROFILE(state, user) {
    state.viewedUserProfile = user
    if (user) {
      state.isLoadingProfile = true // Lade-Spinner starten
      state.commonGroups = [] // Alte Gruppen-Infos löschen
    }
  },
  SET_COMMON_GROUPS(state, groups) {
    state.commonGroups = groups
    state.isLoadingProfile = false // Lade-Spinner stoppen
  },
  UPDATE_MESSAGES_READ_STATUS(state, { groupId, readByUserId, readerInfo, messageIds, readAt }) {
    const messagesInGroup = state.chatMessages[groupId]
    if (!messagesInGroup) return

    messageIds.forEach((msgId) => {
      const message = messagesInGroup.find((m) => m._id === msgId)
      if (message) {
        // Sicherstellen, dass das Array existiert
        if (!message.readBy) {
          Vue.set(message, "readBy", [])
        } // Prüfen, ob schon drin (sollte nicht, aber sicher ist sicher)
        const alreadyRead = message.readBy.some((r) => (r.userId._id || r.userId) === readByUserId)
        if (!alreadyRead) {
          message.readBy.push({
            userId: readerInfo || { _id: readByUserId }, // Pushed das { _id, vorname, bild } Objekt
            readAt: readAt,
          })
        }
      }
    })
  },
  SET_GROUP_MEMBERS(state, { groupId, members }) {
    const group = state.chatGroups.find((g) => g._id === groupId)
    if (group) {
      // Vue.set ist wichtig für die Reaktivität von Objekt-Properties
      Vue.set(group, "members", members)
    }
  },
  SET_EDITING_MESSAGE(state, message) {
    // message kann auch 'null' sein
    state.editingMessage = message

    // Wichtig: Editieren und Antworten schließen sich gegenseitig aus
    if (message) {
      state.replyingToMessage = null
    }
  },
  UPDATE_GROUP_DETAILS(state, updatedGroup) {
    const index = state.chatGroups.findIndex((g) => g._id === updatedGroup._id)
    if (index !== -1) {
      // Wir müssen die 'members' behalten, falls sie nicht mitgeschickt wurden
      const oldGroup = state.chatGroups[index]
      const newGroup = { ...oldGroup, ...updatedGroup }
      Vue.set(state.chatGroups, index, newGroup)
    }
    // Wenn es die aktive Gruppe ist, update auch die activeGroupData (im Getter)
    if (state.activeGroupId === updatedGroup._id) {
      // Das passiert automatisch, da der Getter reaktiv ist.
    }
  },
  // (Mutations bleiben 1:1 gleich)
  SET_REPLYING_TO(state, message) {
    // message kann auch 'null' sein
    state.replyingToMessage = message
  },
  UPDATE_MESSAGE(state, updatedMessage) {
    const groupId = updatedMessage.groupId.toString()
    if (!state.chatMessages[groupId]) return

    const index = state.chatMessages[groupId].findIndex((m) => m._id === updatedMessage._id)
    if (index !== -1) {
      // Vue.set ist nötig, um die Reaktivität im Array zu triggern
      Vue.set(state.chatMessages[groupId], index, updatedMessage)
    }
  },
  SET_ACTIVE_GROUP_ID(state, groupId) {
    state.activeGroupId = groupId
  }, // NEU: Setzt/Updated den Status für einen User

  SET_USER_PRESENCE(state, { userId, isOnline, lastSeen }) {
    Vue.set(state.userPresence, userId, { isOnline, lastSeen })
  },
  SET_LOADING_GROUPS(state, isLoading) {
    state.isLoadingGroups = isLoading
  },
  SET_LOADING_MESSAGES(state, isLoading) {
    state.isLoadingMessages = isLoading
  },
  SET_GROUPS(state, groups) {
    state.chatGroups = groups
  },
  SET_LOADING_MORE_MESSAGES(state, isLoading) {
    state.isLoadingMoreMessages = isLoading
  },
  PREPEND_MESSAGES(state, { groupId, messages }) {
    const existing = state.chatMessages[groupId] || []
    Vue.set(state.chatMessages, groupId, [...messages, ...existing])
  },

  UPDATE_PAGE_INFO(state, { groupId, page, hasMore }) {
    console.log("UPDATE_PAGE_INFO aufgerufen mit:", { groupId, page, hasMore })
    if (!state.chatPageInfo[groupId]) {
      Vue.set(state.chatPageInfo, groupId, {})
    }
    Vue.set(state.chatPageInfo[groupId], "page", page)
    Vue.set(state.chatPageInfo[groupId], "hasMore", hasMore)
  },
  SET_MESSAGES(state, { groupId, messages }) {
    Vue.set(state.chatMessages, groupId, messages)
  },
  ADD_MESSAGE(state, message) {
    const groupId = message.groupId.toString()
    if (!state.chatMessages[groupId]) {
      Vue.set(state.chatMessages, groupId, [])
    }
    const exists = state.chatMessages[groupId].some((m) => m._id === message._id)
    if (!exists) {
      state.chatMessages[groupId].push(message)
    }
  },
  ADD_GROUP(state, group) {
    const exists = state.chatGroups.some((g) => g._id === group._id)
    if (!exists) {
      state.chatGroups.unshift(group)
    }
  },
  SET_ACTIVE_GROUP_ID(state, groupId) {
    state.activeGroupId = groupId
  },
  UPDATE_MESSAGE_REACTIONS(state, { groupId, messageId, reactions }) {
    const messagesInGroup = state.chatMessages[groupId]
    if (!messagesInGroup) return

    const message = messagesInGroup.find((m) => m._id === messageId)
    if (message) {
      // Ersetze das alte 'reactions'-Array komplett mit dem neuen
      Vue.set(message, "reactions", reactions)
    }
  },
}

const actions = {
  saveMessageDraft({ commit }, payload) {
    commit("SAVE_MESSAGE_DRAFT", payload)
  },
  clearMessageDraft({ commit }, groupId) {
    commit("CLEAR_MESSAGE_DRAFT", groupId)
  },
  async returnToPresent({ dispatch, state }) {
    if (!state.activeGroupId) return
    // Einfach Seite 1 neu laden
    await dispatch("fetchMessagesForGroup", state.activeGroupId)
  },
  async performSearch({ commit }, { groupId, query }) {
    if (!query || !query.trim()) {
      commit("CLEAR_SEARCH")
      return
    }

    commit("SET_SEARCH_QUERY", query)
    commit("SET_IS_SEARCHING", true)

    try {
      const { data } = await api.searchGroupMessages(groupId, query)
      commit("SET_SEARCH_RESULTS", data)
    } catch (err) {
      console.error("Such-Fehler:", err)
    } finally {
      commit("SET_IS_SEARCHING", false)
    }
  },

  async jumpToMessage({ commit, dispatch, state }, message) {
    if (state.isJumping) return
    commit("SET_IS_JUMPING", true)

    const groupId = message.groupId._id || message.groupId

    try {
      // 1. Prüfen: Haben wir die Nachricht schon im aktuellen State?
      const existingMsg = state.chatMessages[groupId]?.find((m) => m._id === message._id)

      if (existingMsg) {
        // Nachricht ist schon da -> Einfach scrollen (Das muss die UI machen)
        // Wir geben nur Bescheid, dass wir fertig sind
        return true // Success Flag
      }

      // 2. Wenn nicht da: Frage Server, auf welcher Seite sie ist
      const { data } = await api.getMessagePageContext(groupId, message._id)
      const targetPage = data.page
      if (targetPage > 1) {
        commit("SET_HISTORY_MODE", true) // <--- NEU
      } else {
        commit("SET_HISTORY_MODE", false)
      }
      console.log(`Nachricht gefunden auf Seite ${targetPage}. Lade neu...`)

      // 3. Wir laden die Nachrichten neu, startend bei dieser Seite
      // (Option: Wir könnten "fetchMessagesForGroup" anpassen, dass es eine Seite akzeptiert,
      //  aber wir haben das ja schon vorbereitet!)

      commit("SET_LOADING_MESSAGES", true)

      // Wir laden Seite 'targetPage'
      const { data: messages } = await api.fetchMessagesForGroup(groupId, targetPage)

      // Store aktualisieren (Wir ersetzen die aktuellen Nachrichten, oder?)
      // Strategie: Wenn wir springen, resetten wir den View auf diese Seite.
      commit("SET_MESSAGES", { groupId, messages: messages })

      // Paginierung aktualisieren
      commit("UPDATE_PAGE_INFO", { groupId, page: targetPage, hasMore: true }) // Annahme: Es gibt noch mehr

      // Wir laden zur Sicherheit auch noch die Seite davor (neuer),
      // damit man Kontext nach unten hat, falls die Nachricht ganz unten auf der Seite ist.
      if (targetPage > 1) {
        const { data: newerMessages } = await api.fetchMessagesForGroup(groupId, targetPage - 1)
        // Die müssen VORNE (unten im Chat) angefügt werden, da sie neuer sind
        // Aber ACHTUNG: Unsere Logik in 'SET_MESSAGES' überschreibt.
        // Wir müssen hier clever mergen.
        // Für V1 reicht es, die Zielseite zu laden.
      }

      return true // Signal an UI: "Daten sind da, bitte scrollen!"
    } catch (err) {
      console.error("Jump Fehler:", err)
      return false
    } finally {
      commit("SET_IS_JUMPING", false)
      commit("SET_LOADING_MESSAGES", false)
    }
  },

  clearSearch({ commit }) {
    commit("CLEAR_SEARCH")
  },
  async fetchMessagesForGroup({ commit }, groupId) {
    console.log("fetchMessagesForGroup für Gruppe:", groupId)
    commit("SET_LOADING_MESSAGES", true)
    commit("SET_HISTORY_MODE", false) // <--- NEU: Reset
    commit("UPDATE_PAGE_INFO", { groupId, page: 1, hasMore: true })

    try {
      // Ruft die API explizit für Seite 1 auf
      const { data } = await api.fetchMessagesForGroup(groupId, 1) // Annahme: api.js unterstützt 2. Argument
      commit("SET_MESSAGES", { groupId, messages: data })

      // Wenn weniger als 50 Nachrichten zurückkamen, gibt es keine weiteren Seiten
      if (data.length < 50) {
        // Annahme: Limit ist 50 (wie im Backend)
        commit("UPDATE_PAGE_INFO", { groupId, page: 1, hasMore: false })
      }

      commit("MARK_HISTORY_LOADED", groupId)
    } catch (err) {
      console.error(`Fehler beim Laden der Nachrichten für ${groupId}:`, err)
    } finally {
      commit("SET_LOADING_MESSAGES", false)
    }
  },

  /**
   * NEU: Lädt die nächste Seite und fügt sie vorne an.
   */
  async fetchMoreMessages({ commit, state }, groupId) {
    console.log("fetchMoreMessages für Gruppe:", groupId, state.chatPageInfo, state.isLoadingMoreMessages)
    // Verhindern, wenn wir schon laden oder es nichts mehr gibt
    const info = state.chatPageInfo[groupId]
    if (state.isLoadingMoreMessages || !info || !info.hasMore) {
      return
    }
    console.log("Lade Seite:", info.page + 1)
    commit("SET_LOADING_MORE_MESSAGES", true)
    console.log("isLoadingMoreMessages gesetzt auf true")
    const nextPage = info.page + 1
    console.log("nextPage berechnet als:", nextPage)
    try {
      console.log("Rufe API auf für Gruppe:", groupId, "Seite:", nextPage)
      const { data } = await api.fetchMessagesForGroup(groupId, nextPage)
      console.log(data)
      // Wir fügen die neuen (älteren) Nachrichten VORNE an
      commit("PREPEND_MESSAGES", { groupId, messages: data })

      // Aktualisiere Paginierungs-Status
      commit("UPDATE_PAGE_INFO", {
        groupId,
        page: nextPage,
        hasMore: data.length === 50, // Annahme: Limit ist 50
      })
    } catch (err) {
      console.error(`Fehler beim Laden von Seite ${nextPage}:`, err)
    } finally {
      commit("SET_LOADING_MORE_MESSAGES", false)
    }
  },
  reactToMessage({ state }, { messageId, emoji }) {
    const groupId = state.activeGroupId
    if (!groupId) return
    const payload = { groupId, messageId, emoji }
    socketService.socket.emit("chat:reactToMessage", payload)
  },
  handleReactionUpdated({ commit }, payload) {
    commit("UPDATE_MESSAGE_REACTIONS", payload)
  },
  async broadcastMessage({ commit, state }, { textContent, targetGroupIds }) {
    const payload = {
      targetGroupIds: targetGroupIds,
      messageData: {
        textContent: textContent,
        isForwarded: false, // Ist kein "Forward"
        isBroadcast: true, // <-- Hier setzen wir das Broadcast-Flag!
      },
    }
    socketService.socket.emit("chat:multicastMessage", payload) // (Kein 'await' nötig, das läuft im Hintergrund)
  },

  async forwardMessage({ commit, state }, { message, targetGroupIds }) {
    const payload = {
      targetGroupIds: targetGroupIds,
      messageData: {
        textContent: message.textContent,
        isForwarded: true, // <-- Hier setzen wir das Flag!
        isBroadcast: false,
      },
    }
    socketService.socket.emit("chat:multicastMessage", payload) // (Wir brauchen kein 'await', das läuft im Hintergrund)
  },
  async leaveGroup({ commit }, groupId) {
    try {
      // 1. API aufrufen
      await api.leaveChatGroup(groupId) // 2. Store-Mutation aufrufen
      commit("REMOVE_GROUP_FROM_LIST", groupId)
    } catch (err) {
      console.error("Fehler beim Verlassen der Gruppe:", err)
      throw err // Fehler an Dialog weitergeben
    }
  },
  async deleteGroup({ commit }, groupId) {
    try {
      // 1. API aufrufen
      await api.deleteChatGroup(groupId) // 2. Store-Mutation aufrufen
      commit("REMOVE_GROUP_FROM_LIST", groupId)
    } catch (err) {
      console.error("Fehler beim Verlassen der Gruppe:", err)
      throw err // Fehler an Dialog weitergeben
    }
  },
  showGlobalToast({ commit }, message) {
    // 1. Die Nachricht sofort anzeigen
    commit("SET_GLOBAL_TOAST", message)

    // 2. Die Nachricht nach 5 Sekunden automatisch ausblenden
    setTimeout(() => {
      // (Wir prüfen, ob es noch dieselbe Nachricht ist,
      // falls in der Zwischenzeit 10 neue kamen)
      if (state.globalToastMessage && state.globalToastMessage._id === message._id) {
        commit("SET_GLOBAL_TOAST", null)
      }
    }, 5000) // 5 Sekunden
  },
  emitStartTyping({ state }) {
    const groupId = state.activeGroupId
    if (groupId) {
      socketService.socket.emit("chat:startTyping", { groupId })
    }
  },

  // 2. Wird vom UI aufgerufen, WENN ICH aufhöre zu tippen
  emitStopTyping({ state }) {
    const groupId = state.activeGroupId
    if (groupId) {
      socketService.socket.emit("chat:stopTyping", { groupId })
    }
  },

  // 3. Wird von App.vue aufgerufen, WENN ANDERE tippen
  handleUserStartedTyping({ commit }, payload) {
    commit("ADD_TYPING_USER", payload)
  },

  // 4. Wird von App.vue aufgerufen, WENN ANDERE aufhören
  handleUserStoppedTyping({ commit }, payload) {
    commit("REMOVE_TYPING_USER", payload)
  },
  async viewUserProfile({ commit }, user) {
    commit("SET_VIEWED_PROFILE", user) // Öffnet das Popup

    try {
      // 1. API aufrufen
      const { data: groups } = await api.fetchCommonGroups(user._id)
      // 2. Store-Mutation aufrufen
      commit("SET_COMMON_GROUPS", groups)
    } catch (err) {
      console.error("Fehler beim Laden der gemeinsamen Gruppen:", err)
      commit("SET_COMMON_GROUPS", []) // Leeres Array bei Fehler
    }
  },
  closeUserProfile({ commit }) {
    commit("SET_VIEWED_PROFILE", null)
  },
  sendReadReceipts({ state }, { groupId, messageIds }) {
    const payload = {
      groupId,
      messageIds,
    }
    socketService.socket.emit("chat:messagesRead", payload)
  },
  handleSocketMessagesRead({ commit }, payload) {
    commit("UPDATE_MESSAGES_READ_STATUS", payload)
  },
  async addMembersToGroup({ commit }, { groupId, memberIds }) {
    try {
      // 1. API aufrufen (gibt die *neue, populierte* Mitgliederliste zurück)
      const { data: updatedGroup } = await api.addChatMembers(groupId, memberIds) // 2. Store-Mutation aufrufen
      commit("UPDATE_GROUP_DETAILS", updatedGroup) // 3. TODO: Socket-Event 'chat:memberAdded' an die neuen User senden
    } catch (err) {
      console.error("Fehler beim Hinzufügen von Mitgliedern:", err)
      throw err // Fehler an Dialog weitergeben
    }
  },
  async kickGroupMember({ commit }, { groupId, userIdToRemove }) {
    try {
      // 1. API aufrufen (gibt die *neue* Mitgliederliste zurück)
      const { data: updatedGroup } = await api.kickChatMember(groupId, userIdToRemove) // 2. Store-Mutation aufrufen
      commit("UPDATE_GROUP_DETAILS", updatedGroup) // 3. TODO: Socket-Event 'chat:memberKicked' an alle senden
    } catch (err) {
      console.error("Fehler beim Entfernen des Mitglieds:", err)
      throw err // Fehler an Dialog weitergeben
    }
  },
  async updateGroupMemberRole({ commit }, { groupId, userIdToUpdate, newRole }) {
    try {
      // 1. API aufrufen (gibt die *neue* Mitgliederliste zurück)
      const { data: updatedGroup } = await api.updateChatMemberRole(groupId, userIdToUpdate, newRole) // 2. Store-Mutation aufrufen
      commit("UPDATE_GROUP_DETAILS", updatedGroup) // 3. TODO: Socket-Event 'chat:roleUpdated' an alle senden
    } catch (err) {
      console.error("Fehler beim Ändern der Rolle:", err)
      throw err // Fehler an Dialog weitergeben
    }
  },
  setReplyTo({ commit }, message) {
    commit("SET_REPLYING_TO", message)
  },
  setEditingMessage({ commit }, message) {
    commit("SET_EDITING_MESSAGE", message)
  },

  /**
   * Bricht die Bearbeitung ab
   */
  cancelEditing({ commit }) {
    commit("SET_EDITING_MESSAGE", null)
  },

  /**
   * Sendet die bearbeitete Nachricht an den Server
   */
  dispatchEditMessage({ commit, state }, payload) {
    // <-- 'payload' statt 'newTextContent'
    if (!state.editingMessage) return
    const finalPayload = {
      groupId: state.editingMessage.groupId,
      messageId: state.editingMessage._id,
      // Wir übergeben das *ganze* Payload-Objekt (mit 'textContent' und 'mentionIds')
      newPayload: payload,
    }
    socketService.socket.emit("chat:editMessage", finalPayload) // Bearbeitungs-Modus beenden
    commit("SET_EDITING_MESSAGE", null)
  },

  async saveGroupDetails({ commit }, { groupId, updateData }) {
    try {
      // 1. API aufrufen
      const { data: updatedGroup } = await api.updateGroup(groupId, updateData)

      // 2. Store-Mutation aufrufen
      commit("UPDATE_GROUP_DETAILS", updatedGroup)

      // 3. TODO: Socket-Event 'chat:groupUpdated' an alle senden
    } catch (err) {
      console.error("Fehler beim Speichern der Gruppe:", err)
      throw err // Fehler an Dialog weitergeben
    }
  },
  /**
   * Sendet das "Lösch"-Event an den Server
   */
  deleteMessage({ state }, message) {
    const payload = {
      groupId: message.groupId,
      messageId: message._id,
    }
    socketService.socket.emit("chat:deleteMessage", payload)
  },
  async createGroup({ commit, dispatch }, groupData) {
    try {
      // ALT: const { data: newGroup } = await axios.post("/api/chat/groups", groupData)
      // NEU:
      const { data: newGroup } = await api.createGroup(groupData)

      commit("ADD_GROUP", newGroup)
      dispatch("setActiveGroup", newGroup._id)
    } catch (err) {
      console.error("Fehler beim Erstellen der Gruppe:", err.response.data)
      throw err
    }
  },

  async startDirectChat({ commit, dispatch }, targetUserId) {
    try {
      const { data: group } = await api.createOrGetDirectChat(targetUserId)

      // Prüfen ob die Gruppe schon im Store ist, wenn nicht hinzufügen
      commit("ADD_GROUP", group)

      // Anschließend die Gruppe als aktiv setzen (Chat öffnen)
      dispatch("setActiveGroup", group._id)
      return group
    } catch (err) {
      console.error("Fehler beim Starten des Einzelchats:", err)
      throw err
    }
  },

  async fetchGroups({ commit }) {
    commit("SET_LOADING_GROUPS", true)
    try {
      const { data: groups } = await api.fetchGroups()
      commit("SET_GROUPS", groups) // --- NEU: Initialen Presence-Status aus den Gruppen füllen ---

      if (false && groups) {
        groups.forEach((group) => {
          ;(group.members || []).forEach((member) => {
            if (member.userId) {
              // Sicherstellen, dass der User da ist
              commit("SET_USER_PRESENCE", {
                userId: member.userId._id,
                isOnline: member.userId.isOnline,
                lastSeen: member.userId.lastSeen,
              })
            }
          })
        })
      } // --- ENDE NEU ---
    } catch (err) {
      console.error("Fehler beim Laden der Chat-Gruppen:", err)
    } finally {
      commit("SET_LOADING_GROUPS", false)
    }
  },

  handleUserOnline({ commit }, payload) {
    commit("SET_USER_PRESENCE", {
      userId: payload.userId,
      isOnline: true,
    })
  },
  /**
   * Wird von App.vue aufgerufen (Socket 'chat:userOffline')
   */ handleUserOffline({ commit }, payload) {
    commit("SET_USER_PRESENCE", {
      userId: payload.userId,
      isOnline: false,
      lastSeen: payload.lastSeen,
    })
  },
  async setActiveGroup({ commit, state, dispatch }, groupId) {
    commit("SET_ACTIVE_VIEW", "chat")
    commit("SET_ACTIVE_GROUP_ID", groupId)
    if (!groupId) {
      return
    }
    dispatch("markGroupAsRead", groupId) // (Dein 'loadedGroupHistories'-Check bleibt gleich)

    await dispatch("fetchMessagesForGroup", groupId)
  },
  async openPinboard({ commit, dispatch }) {
    commit("SET_ACTIVE_VIEW", "pinboard")
    await dispatch("fetchPinboard")
  },

  async openSupportChat({ commit, dispatch }) {
    try {
      const { data: group } = await api.startSupportChat()
      // Gruppe zum Store hinzufügen (falls noch nicht da)
      commit("ADD_GROUP", group)
      // Direkt in die Gruppe wechseln
      await dispatch("setActiveGroup", group._id)
    } catch (err) {
      console.error("Fehler beim Öffnen des Support-Chats:", err)
    }
  },

  // NEU:
  async fetchPinboard({ commit }) {
    commit("SET_PINBOARD_LOADING", true)
    try {
      const { data } = await api.fetchPinboard() // (Noch nicht in chatApi.js, fügen wir gleich hinzu)
      commit("SET_PINBOARD_PINS", data)
    } catch (err) {
      console.error("Pinboard konnte nicht geladen werden", err)
    } finally {
      commit("SET_PINBOARD_LOADING", false)
    }
  },

  // NEU:
  async savePersonalPin({ commit }, message) {
    commit("ADD_PERSONAL_PIN", message) // Optimistisch
    try {
      await api.savePersonalPin(message._id) // (chatApi.js)
    } catch (err) {
      commit("REMOVE_PERSONAL_PIN", message._id) // Rollback
      // this.$toast.error("Fehler beim Merken")
    }
  },

  // NEU:
  async removePersonalPin({ commit }, message) {
    commit("REMOVE_PERSONAL_PIN", message._id) // Optimistisch
    try {
      await api.removePersonalPin(message._id) // (chatApi.js)
    } catch (err) {
      commit("ADD_PERSONAL_PIN", message) // Rollback
      // this.$toast.error("Fehler")
    }
  },

  // NEU:
  async saveGlobalPin({ dispatch }, message) {
    try {
      await api.saveGlobalPin(message._id) // (chatApi.js)
      await dispatch("fetchPinboard") // Neu laden
    } catch (err) {
      // this.$toast.error("Fehler beim Pinnen")
    }
  },

  // NEU:
  async removeGlobalPin({ dispatch }, message) {
    try {
      await api.removeGlobalPin(message._id) // (chatApi.js)
      await dispatch("fetchPinboard") // Neu laden
    } catch (err) {
      // this.$toast.error("Fehler beim Lösen")
    }
  },
  sendMessage({ state, commit }, messagePayload) {
    return new Promise((resolve, reject) => {
      if (!state.activeGroupId) return reject(new Error("Keine aktive Gruppe"))

      const socket = socketService.socket
      if (!socket) return reject(new Error("Socket nicht initialisiert"))

      // Das ist die eigentliche Sende-Logik, als kleine Funktion verpackt
      const sendPayload = () => {
        const payload = {
          ...messagePayload,
          groupId: state.activeGroupId,
          replyToMessageId: state.replyingToMessage ? state.replyingToMessage._id : null,
        }
        socket.emit("chat:sendMessage", payload)
        if (state.replyingToMessage) {
          commit("SET_REPLYING_TO", null)
        }
        resolve()
      }

      // 1. Wenn verbunden -> Sofort senden!
      if (socket.connected) {
        sendPayload()
      } else {
        // 2. Nicht verbunden? -> Wir stoßen den Reconnect manuell an
        socket.connect()

        let timeout

        // Listener, der wartet, bis die Verbindung (wieder) da ist
        const onConnect = () => {
          clearTimeout(timeout) // Timer abbrechen
          socket.off("connect", onConnect) // Listener aufräumen
          sendPayload() // Nachricht senden!
        }

        socket.once("connect", onConnect)

        // 3. Nach 3 Sekunden geben wir wirklich auf
        timeout = setTimeout(() => {
          socket.off("connect", onConnect) // Listener aufräumen
          reject(new Error("Keine Verbindung zum Chat-Server möglich."))
        }, 3000) // 3000 ms = 3 Sekunden Toleranz
      }
    })
  },
  handleSocketNewMessage({ commit, rootState }, message) {
    // <-- 'rootState' hinzugefügt
    // 1. Füge Nachricht zum Chat-Fenster hinzu (bleibt gleich)
    commit("ADD_MESSAGE", message)

    // 2. Hol die ID des eingeloggten Users
    const myUserId = rootState.userStore.user._id

    // 3. Aktualisiere die Gruppen-VORSCHAU (Badge, Text, Sortierung)
    commit("UPDATE_GROUP_ON_NEW_MESSAGE", { message, myUserId })
  },
  /**
   * Teilt dem Server mit, dass wir diesen Chat JETZT gelesen haben.
   * (ANGEPASST)
   */ markGroupAsRead({ commit, state }, groupId) {
    if (!groupId) return
    socketService.socket.emit("chat:markGroupRead", { groupId }) // ALT: commit('UPDATE_GROUP_UNREAD_STATUS', { groupId, isRead: true });
    // NEU:
    commit("MARK_GROUP_READ", { groupId })
  },

  handleSocketGroupAdded({ commit, dispatch }, group) {
    commit("ADD_GROUP", group)
  },
  handleSocketMessageUpdated({ commit }, updatedMessage) {
    commit("UPDATE_MESSAGE", updatedMessage)
  },
}

const getters = {
  isPersonallyPinned: (state) => (messageId) => {
    return state.pinboardPersonal.some((m) => m._id === messageId)
  },
  isGloballyPinned: (state) => (messageId) => {
    return state.pinboardGlobal.some((p) => p.messageId._id === messageId)
  },
  getHasMoreMessages: (state) => (groupId) => {
    if (!state.chatPageInfo[groupId]) return true // Standard
    return state.chatPageInfo[groupId].hasMore
  },
  getTypingUsersForActiveGroup: (state, getters) => {
    // <-- Wir brauchen 'getters'
    const activeGroupId = state.activeGroupId
    const activeGroup = getters.activeGroupData // Den Getter haben wir schon!

    // 2. Hol die Liste der tippenden IDs für diese Gruppe
    const typingIds = state.typingUsers[activeGroupId] || []

    if (!activeGroup || !activeGroup.members || typingIds.length === 0) {
      return [] // Nichts zu tun
    }

    return activeGroup.members.filter((member) => typingIds.includes(member.userId._id))
  },
  activeGroupMessages: (state) => {
    return state.chatMessages[state.activeGroupId] || []
  },
  activeGroupData: (state) => {
    return state.chatGroups.find((g) => g._id === state.activeGroupId)
  },
  getPresenceByUserId: (state) => (userId) => {
    return state.userPresence[userId] || { isOnline: false }
  },
}

export const chatStore = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
